import { IApplicationState } from '../../types/redux';

export const selectHiddenOfferIds = (state: IApplicationState): number[] => state.hiddenObjects.ids;
